import { API_URL_AQ_PAY_UBQ, API_URL_AQ_PAY_PAYMENT } from '../../config';
import i18n from '../../i18n';

export const getPaymentUrl = async (qr) => {
    if (!qr) {
        throw new Error(i18n.t('payment.missingQr'));
    }

    let response;
    try {
        response = await fetch(API_URL_AQ_PAY_UBQ + qr, {
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        });
    } catch (fetchError) {
        console.error('Fetch error:', fetchError);
        throw new Error(i18n.t('payment.serverConnectionError'));
    }

    try {
        const data = await response.json();
        return data;
    } catch (parseError) {
    // Проверка статуса ответа до парсинга
        if (!response.ok) {
            throw new Error(
                i18n.t('payment.serverError', {
                    status: response.status,
                    statusText: response.statusText
                })
            );
        }        
        throw new Error(i18n.t('payment.invalidResponse'));
    }
};

export const getPaymentData = async (qr) => {
    try {
        const response = await fetch(API_URL_AQ_PAY_PAYMENT + qr, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        });
        // if (!response.ok) throw new Error(i18n.t('payment.serverError', { status: response.status, statusText: response.statusText }));
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
        return [];
    }
};